import BillInvoice from './BillInvoice';

export default BillInvoice;
